import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
  font-family: "Font";
  color: #ffffff;
  background-image: url('/images/fondo.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.42);
    backdrop-filter: blur(8px);
  }
`;

const ErrorPanel = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 640px;
  padding: 36px 28px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.48);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(16px);
`;

const ErrorTitle = styled.h1`
  color: #ffffff;
  font-size: clamp(2rem, 6vw, 3.4rem);
  margin-bottom: 1rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
`;

const ErrorMessage = styled.p`
  color: rgba(255, 255, 255, 0.76);
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 2rem;
`;

const ErrorDetails = styled.details`
  margin-bottom: 2rem;
  text-align: left;

  summary {
    color: #ff6b35;
    cursor: pointer;
    margin-bottom: 1rem;
  }

  pre {
    max-height: 240px;
    overflow: auto;
    border-radius: 12px;
    padding: 1rem;
    color: rgba(255, 255, 255, 0.82);
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    white-space: pre-wrap;
  }
`;

const ReloadButton = styled.button`
  background: linear-gradient(135deg, #ff6b35, #ff8c5a);
  color: white;
  border: none;
  padding: 13px 24px;
  border-radius: 999px;
  cursor: pointer;
  font-family: "Font";
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 10px 26px rgba(255, 107, 53, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 32px rgba(255, 107, 53, 0.38);
  }
`;

/**
 * Error Boundary Component
 * Captura errores de React en toda la aplicación y muestra UI amigable
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para mostrar la UI de fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Loggear el error (en producción, enviar a servicio de logging)
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);

    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // UI de error personalizada
      return (
        <ErrorContainer>
          <ErrorPanel>
            <ErrorTitle>Algo salió mal</ErrorTitle>
            <ErrorMessage>
              Lo sentimos, ha ocurrido un error inesperado. Recarga la página o inténtalo más tarde.
            </ErrorMessage>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <ErrorDetails>
                <summary>Detalles del error (desarrollo)</summary>
                <pre>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </ErrorDetails>
            )}

            <ReloadButton onClick={this.handleReload}>
              Recargar página
            </ReloadButton>
          </ErrorPanel>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
